import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { News } from '../../models/news.model';
import { NewsListDelegate } from '../../services/DataDelegate/NewsDelegate/news.list.delegate';

@Component
export default class EpicNewsPopular extends Vue {
    public title: string = 'EpicNewsPopular';
    public newsListDelegate = new NewsListDelegate();
    @Prop({ default: null })
    public inputData: any;
    public data: News[] = [];
    public loading: boolean = false;
    @Watch('inputData', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
        this.data = val;
    }
    public async created() {
        this.$store.state.newsList.selectType = this.$route.params.type;
        if (this.inputData) {
            this.data = this.inputData;
            return;
        }
        this.loading = true;
        const result = await this.newsListDelegate.getPopularList();
        this.loading = false;
        this.data = result.data.sort(function(a: News, b: News) {
            return a.browseCount - b.browseCount;
        });
    }
    public goDetail(path: string) {
        this.$router.push(path);
    }
}
